'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import { useState } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { ReviewsCardProps } from '@/types/trustpilot';
import Slider from '@/components/Slider/Slider';
import ReviewsCard from '../ReviewsCard/ReviewsCard';
export default function ReviewsSlider(t0) {
  const $ = _c(23);
  const {
    reviews,
    trustpilotURL
  } = t0;
  const [sliderProgress, setSliderProgress] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  let t1;
  if ($[0] !== pageCount || $[1] !== sliderProgress) {
    t1 = Math.round(sliderProgress * (pageCount - 1));
    $[0] = pageCount;
    $[1] = sliderProgress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentPage = t1;
  const t = useTranslations();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      root: "[--slides-to-show:1.6] sm:[--slides-to-show:3] md:px-20 md:[--slides-to-show:3.2] lg:[--slides-to-show:5] xl:[--slides-to-show:6]",
      navPrev: "!hidden bg-black text-white md:!flex lg:size-16",
      navNext: "!hidden bg-black text-white md:!flex lg:size-16"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (progress, pages) => {
      setSliderProgress(progress);
      setPageCount(pages);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== reviews) {
    t4 = reviews.map(_temp);
    $[5] = reviews;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="relative"><Slider className={t2} showNavigation={true} onProgressChange={t3} noPadding={true}>{t4}</Slider></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== pageCount) {
    t6 = Array.from({
      length: pageCount
    });
    $[9] = pageCount;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== currentPage || $[12] !== t6) {
    t7 = <div className="flex justify-center gap-1">{t6.map((_, index) => <span key={index} className={clsx("h-1 w-1 rounded-full transition-colors duration-300", index === currentPage ? "bg-black" : "bg-gray-300")} />)}</div>;
    $[11] = currentPage;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("trustpilot.viewAllReviews");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8 || $[17] !== trustpilotURL) {
    t9 = <div className="p-x-container flex w-full justify-center"><Button size="m" asChild={true} variant="ghost" className="mt-4 inline-block w-full px-6 py-3 font-bold sm:w-fit md:mt-6"><Link href={trustpilotURL} target="_blank">{t8}</Link></Button></div>;
    $[16] = t8;
    $[17] = trustpilotURL;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t9) {
    t10 = <>{t5}{t7}{t9}</>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(item) {
  return <ReviewsCard key={item.id} {...item} />;
}